import LayerSwitcherImage from "ol-ext/control/LayerSwitcherImage";
import CommonControls from "./ol-geodok/control/CommonControls";
import BaseLayerSwitcher from "./ol-geodok/control/BaseLayerSwitcher";
import config from './config';
import {get as getProjection,transformExtent} from 'ol/proj';

let customMapOptions = config.getCustomMapOptions();
let controls = [];

controls.push(new BaseLayerSwitcher());

let mainbar = new CommonControls({
	zoomtoextent : {
		extent : transformExtent(customMapOptions.extent, "EPSG:25832","EPSG:3857")
	}
})
mainbar.setPosition('left');

controls.push(mainbar);

export default controls;